import * as Enviroment from "./models/Enviroment";

// IMPORTANT - Remeber that when bringing in external strings as part of regexes you need to escape the special characters

const escapeRegExp = (string: string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string

// Local stacks are told apart by the port they publish, not the hostname - several
// workspaces serve the identical *.local names at once. So the browser's Origin header
// arrives as `https://auth.sailhomes.local:10443`, and an origin pattern with no port
// rejects it: validateHeaders then 415s the request and login is impossible on every
// workspace except the one holding 443. Pinning the host is what makes origin checking
// worth anything; the port adds nothing an attacker controls.
const OPTIONAL_PORT = "(?::\\d+)?";

const validURLPartsRegexOrString = (env: Enviroment.T): string => {
    const parts: Array<string> = [];
    const domainNameEscaped = escapeRegExp(Enviroment.getDomainNameFromEnv(env));
    if (domainNameEscaped !== "") {
        parts.push(`https://[a-zA-Z0-9-]+\\.${domainNameEscaped}${OPTIONAL_PORT}|https://${domainNameEscaped}${OPTIONAL_PORT}`);
    }
    const sailProbateDomainNameEscaped = escapeRegExp(Enviroment.getSailProbateDomainNameFromEnv(env));
    if (sailProbateDomainNameEscaped !== "") {
        parts.push(`https://[a-zA-Z0-9-]+\\.${sailProbateDomainNameEscaped}${OPTIONAL_PORT}|https://${sailProbateDomainNameEscaped}${OPTIONAL_PORT}`);
    }
    const sailLegalDomainNameEscaped = escapeRegExp(Enviroment.getSailLegalDomainNameFromEnv(env));
    if (sailLegalDomainNameEscaped !== "") {
        parts.push(`https://[a-zA-Z0-9-]+\\.${sailLegalDomainNameEscaped}${OPTIONAL_PORT}|https://${sailLegalDomainNameEscaped}${OPTIONAL_PORT}`);
    }
    const joinedParts = parts.join("|");
    if (joinedParts !== "") {
        return joinedParts;
    }
    // Handle missing vars being empty and allowing possibly weird strings
    return "https://sailhomes.co.uk";
};

export const constants = {
    VALID_SAILHOMES_CORS_URL: (env: Enviroment.T): string =>
        `^(${validURLPartsRegexOrString(env)})$`,
    VALID_SAILHOMES_REDIRECT_URL: (env: Enviroment.T): string =>
        `^(${validURLPartsRegexOrString(env)})(:[0-9]+)?([/?#][A-Za-z0-9/?#_&%=+.:,;@$'|*!()~\-]*)?$`,
    VALID_SAILHOMES_EMAIL: (env: Enviroment.T): string =>
        `^.*@${escapeRegExp(Enviroment.getDomainNameFromEnv(env))}$`,
    VALID_SAILLEGAL_EMAIL: (env: Enviroment.T): string =>
    `^.*@((${escapeRegExp(Enviroment.getSailLegalDomainNameFromEnv(env))})|(saillegal\\.co\\.uk))$`,
};
